import { actionKitImpFunction } from '../../../../components/ozmoit/common';
import { PaginationQueryDto } from '../../../../types/paginationRequestType';
import {
  getNonStructuredSectionsActionRequest,
  getNonStructuredSectionsFormActionRequest,
} from '../api';
import { NonStructuredSectionFilters } from '../types';

const getNonStructuredSectionsAction = actionKitImpFunction(
  async (params: PaginationQueryDto<NonStructuredSectionFilters>) => {
    const response = await getNonStructuredSectionsActionRequest(params);
    if (response.error) {
      throw new Error('Error fetching paginated data');
    }

    const { data } = response;

    return data;
  },
);

const getNonStructuredSectionsFiltersFormAction = actionKitImpFunction(
  async () => {
    const response = await getNonStructuredSectionsFormActionRequest();
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    const { data } = response;

    return data;
  },
);

export {
  getNonStructuredSectionsAction,
  getNonStructuredSectionsFiltersFormAction,
};
